module.exports = function() {
  return new Worker(__webpack_public_path__ + "f61a5d3cf1c50133bc32.worker.js");
};